export type MobileColumnLayout = 'auto' | 'stack' | '2' | '3' | 'same'

export const MOBILE_COLUMN_LAYOUT_OPTIONS: Record<
  2 | 3 | 4,
  Array<{ value: MobileColumnLayout; label: string }>
> = {
  2: [
    { value: 'auto', label: 'Αυτόματο (στοίβα στο κινητό)' },
    { value: 'stack', label: 'Στοίβα (1 στήλη)' },
    { value: '2', label: '2 στήλες (ίδιες)' },
    { value: 'same', label: 'Ίδιο με desktop' },
  ],
  3: [
    { value: 'auto', label: 'Αυτόματο (στοίβα στο κινητό)' },
    { value: 'stack', label: 'Στοίβα (1 στήλη)' },
    { value: '2', label: '2 στήλες' },
    { value: '3', label: '3 στήλες (μικρές)' },
    { value: 'same', label: 'Ίδιο με desktop' },
  ],
  4: [
    { value: 'auto', label: 'Αυτόματο (2×2 στο κινητό)' },
    { value: 'stack', label: 'Στοίβα (1 στήλη)' },
    { value: '2', label: '2 στήλες (2×2)' },
    { value: '3', label: '3 στήλες' },
    { value: 'same', label: 'Ίδιο με desktop' },
  ],
}

export function getMobileGridColumns(
  desktopCount: 2 | 3 | 4,
  layout: MobileColumnLayout | undefined
): string {
  const mode = layout || 'auto'

  if (mode === 'same') {
    return 'var(--desktop-cols)'
  }
  if (mode === 'stack') {
    return 'minmax(0, 1fr)'
  }
  if (mode === '2') {
    return 'repeat(2, minmax(0, 1fr))'
  }
  if (mode === '3') {
    return 'repeat(3, minmax(0, 1fr))'
  }

  if (desktopCount === 2) {
    return 'minmax(0, 1fr)'
  }
  if (desktopCount === 3) {
    return 'minmax(0, 1fr)'
  }
  return 'repeat(2, minmax(0, 1fr))'
}

export function getColumnContainerClasses(
  desktopCount: 2 | 3 | 4,
  mobileLayout: MobileColumnLayout | undefined,
  ratioClass: string
): string[] {
  const mode = mobileLayout || 'auto'
  return [ratioClass, `cols-count-${desktopCount}`, `mobile-layout-${mode}`]
}

export function getColumnContainerStyle(
  desktopCount: 2 | 3 | 4,
  mobileLayout: MobileColumnLayout | undefined,
  gap?: string
): Record<string, string> {
  return {
    gap: gap || '1rem',
    '--mobile-cols': getMobileGridColumns(desktopCount, mobileLayout),
    '--desktop-cols':
      desktopCount === 2
        ? 'var(--ratio-cols-2, 1fr 1fr)'
        : desktopCount === 3
          ? 'var(--ratio-cols-3, 1fr 1fr 1fr)'
          : 'repeat(4, minmax(0, 1fr))',
  }
}

/** On the public site, collapse empty columns so a single widget can use full width. */
export function getActiveColumnsGridStyle(
  columnLengths: number[],
  isEditable: boolean
): Record<string, string> {
  if (isEditable) return {}

  const activeCount = columnLengths.filter((count) => count > 0).length
  if (activeCount <= 1) {
    return { gridTemplateColumns: '1fr' }
  }
  if (activeCount === 2) {
    return { gridTemplateColumns: '1fr 1fr' }
  }
  if (activeCount === 3 && columnLengths.length === 4) {
    return { gridTemplateColumns: '1fr 1fr 1fr' }
  }

  return {}
}
